import { atomWithKey as atom } from "./atomWithKey";
import { AccountAction } from "../Types/Types/MyAccount/AccountAction";
import { IBookingsSearchResponse, IPhoneNumberVerifications } from "../Types/Index";
import { IExperienceFields, IManageWidgetItem, ISpecialAssistancePref, ITravelDay } from "../Types/Interface/IWidgetsReqAndRes";
import { IFavoriteDepartureFields, IFavoriteTripsForTodayFields, TravelDay } from "../Types/Types/OffersResponse";

export const accountActionAtom = atom<AccountAction[]>({
    key: "accountActionAtom",
    default: [
        {
            key: 1,
            name: "personalInformation",
            label: "Personal Information",
            isComplete: false,
            imageSrc: "/assets/my_account/user.svg",
            height: 20,
            width: 20,
            statusIcon: true,
        },
        {
            key: 2,
            label: "Personalize Experience",
            name: "personalizeExperience",
            isComplete: false,
            imageSrc: "/assets/my_account/personalize.svg",
            height: 20,
            width: 20,
            statusIcon: true,
        },
        {
            key: 3,
            label: "Companions",
            name: "companions",
            isComplete: false,
            imageSrc: "/assets/my_account/users-group.svg",
            height: 20,
            width: 20,
            statusIcon: true,
        },
        {
            key: 4,
            label: "Payments & Vouchers",
            name: "paymentVouchers",
            isComplete: false,
            imageSrc: "/assets/my_account/credit-card.svg",
            height: 20,
            width: 20,
            statusIcon: true,
        },
        // {
        //     key: 5,
        //     label: "Promo Codes",
        //     name: "promoCodes",
        //     imageSrc: "/assets/my_account/coupon-star.svg",
        //     height: 20,
        //     width: 20,
        //     statusIcon: false,
        // },
        {
            key: 6,
            label: "Account Management",
            name: "accountManagement",
            imageSrc: "/assets/my_account/user-settings.svg",
            height: 20,
            width: 20,
            statusIcon: false,
        },
    ],
});

export const isSelectingOriginAtom = atom<boolean>({
    key: "isSelectingOriginAtom",
    default: false
})

export const isSelectingDestinationAtom = atom<boolean>({
    key: "isSelectingDestinationAtom",
    default: false
})

export const isPassengerDropdownOpenAtom = atom<boolean>({
    key: "isPassengerDropdownOpenAtom",
    default: false
})

export const activeAccountActionAtom = atom<string>({
    key: "activeAccountActionAtom",
    default: "",
});

//Personal Information
export const showInvoiceDetailsAtom = atom<boolean>({
    key: "showInvoiceDetailsAtom",
    default: false
});

export const isPersonalInfoModifiedAtom = atom<boolean>({
    key: "isPersonalInfoModifiedAtom",
    default: false
});

export const isPersonalInfoFormValidAtom = atom<boolean>({
    key: "isPersonalInfoFormValidAtom",
    default: true
});

export const accountProgressAtom = atom<number>({
    key: "accountProgressAtom",
    default: 0
});

export const isOtpVerifiedAtom = atom<boolean>({
    key: "isOtpVerifiedAtom",
    default: false
});

export const phoneVerificationResponseAtom = atom<IPhoneNumberVerifications | null>({
    key: "phoneVerificationResponseAtom",
    default: null,
});

export const otpErrorAtom = atom<string>({
    key: "otpErrorAtom",
    default: "",
});


export const defaultManageIncludeWidgets: IManageWidgetItem[] = [
    {
        id: 1,
        key: "multiBooking",
        subKey: "",
        itemType: "include",
        valueKey: "MultiBooking",
        value: true,
    },
    {
        id: 2,
        key: "popularTrips",
        subKey: "",
        itemType: "include",
        valueKey: "PopularTrips",
        value: true,
    },
    {
        id: 3,
        key: "enhanceYourTrip",
        subKey: "",
        itemType: "include",
        valueKey: "EnhanceYourTrip",
        value: true,
    },
    {
        id: 4,
        key: "helpAndUsefulInformation",
        subKey: "",
        itemType: "include",
        valueKey: "HelpAndUseFullInfo",
        value: true,
    },
];

export const manageIncludeWidgetsAtom = atom<IManageWidgetItem[]>({
    key: "manageIncludeWidgetsAtom",
    default: defaultManageIncludeWidgets,
});

export const defaultManageWidgets: IManageWidgetItem[] = [
    {
        id: 5,
        key: "bookItAgain",
        subKey: "bookItAgainSubTitle",
        itemType: "",
        valueKey: "BookItAgain",
        value: false,
    },
    {
        id: 6,
        key: "favoriteDepartures",
        subKey: "favoriteDeparturesSubTitle",
        itemType: "",
        valueKey: "FavoriteDepartures",
        value: false,
    },
    {
        id: 7,
        key: "favoriteTripsForToday",
        subKey: "favoriteTripsForTodaySubTitle",
        itemType: "",
        valueKey: "FavoriteTripsForToday",
        value: false,
    },
];

export const manageWidgetsAtom = atom<IManageWidgetItem[]>({
    key: "manageWidgetsAtom",
    default: defaultManageWidgets,
});

export const defaultValuePersonalizeValue = [
    {
        key: 1,
        name: "from",
        label: "From",
        value: "",
        valueLabel: "",
        placeHolder: "Select Origin",
        drawerTitle: "Origin",
    },
    {
        key: 2,
        name: "to",
        label: "To",
        value: "",
        valueLabel: "",
        placeHolder: "Select destination",
        drawerTitle: "Destination",
    },
    {
        key: 3,
        name: "travelDays",
        label: "Travel Days",
        value: "",
        valueLabel: "",
        placeHolder: "Select travel days",
        drawerTitle: "travelDays",
    },
    {
        key: 4,
        name: "passengerType",
        label: "Passenger Type",
        value: "",
        valueLabel: "",
        placeHolder: "Select passenger type",
        drawerTitle: "passengerType",
    },
    {
        key: 5,
        name: "outboundDepartureTime",
        label: "Outbound Departure Time",
        value: "",
        valueLabel: "",
        placeHolder: "Select outbound departure time",
        drawerTitle: "outboundDepartureTime",
    },
    {
        key: 6,
        name: "inboundDepartureTime",
        label: "Inbound Departure Time",
        value: "",
        valueLabel: "",
        placeHolder: "Select Inbound departure time",
        drawerTitle: "inboundDepartureTime",
    },
    {
        key: 7,
        name: "classTicketOption",
        label: "Class & Ticket Option",
        value: "",
        valueLabel: "",
        placeHolder: "Select class & ticket option",
        drawerTitle: "classTicketOption",
    },
    {
        key: 8,
        name: "seating",
        label: "Seating",
        value: "",
        valueLabel: "",
        placeHolder: "Select seating",
        drawerTitle: "seating",
    },
    {
        key: 9,
        name: "addOns",
        label: "Extras",
        value: "",
        valueLabel: "",
        placeHolder: "Select Extras",
        drawerTitle: "addOns",
    },
    // {
    //     key: 10,
    //     name: "specialAssistance",
    //     label: "Special Assistance",
    //     value: "",
    //     valueLabel: "",
    //     placeHolder: "Select Special Assistance",
    //     drawerTitle: "specialAssistance",
    // },
];

export const experienceFieldsAtom = atom<IExperienceFields[]>({
    key: "experienceFieldsAtom",
    default: defaultValuePersonalizeValue,
});

export const defaultValueForFavouriteDeparture = [
    {
        key: 1,
        name: "from",
        label: "From",
        value: "",
        valueLabel: "",
        placeHolder: "No Preference",
        drawerTitle: "Origin",
        valueCode: "",
    },
    {
        key: 2,
        name: "to",
        label: "To",
        value: "",
        valueLabel: "",
        placeHolder: "No Preference",
        drawerTitle: "Destination",
        valueCode: "",
    },
    {
        key: 3,
        name: "outboundDepartureTime",
        label: "Outbound Departure Time",
        value: "",
        valueLabel: "",
        placeHolder: "Select outbound departure time",
        drawerTitle: "outboundDepartureTime",
        valueCode: "",
    },
    {
        key: 4,
        name: "classTicketOption",
        label: "Class & Ticket Option",
        value: "",
        valueLabel: "",
        placeHolder: "No Preference",
        drawerTitle: "classTicketOption",
        valueCode: "",
    }
];

export const favoriteDepartureFieldsAtom = atom<IFavoriteDepartureFields[]>({
    key: "favoriteDepartureFieldsAtom",
    default: defaultValueForFavouriteDeparture,
});

export const defaultValueForFavouriteTripsForToday = [
    {
        key: 1,
        name: "from",
        label: "From",
        value: "",
        valueLabel: "",
        placeHolder: "No Preference",
        drawerTitle: "Origin",
        valueCode: "",
    },
    {
        key: 2,
        name: "to",
        label: "To",
        value: "",
        valueLabel: "",
        placeHolder: "No Preference",
        drawerTitle: "Destination",
        valueCode: "",
    },
    {
        key: 3,
        name: "classTicketOption",
        label: "Class & Ticket Option",
        value: "",
        valueLabel: "",
        placeHolder: "No Preference",
        drawerTitle: "classTicketOption",
        valueCode: "",
    }
];

export const favoriteTripsForTodayFieldsAtom = atom<IFavoriteTripsForTodayFields[]>({
    key: "favoriteTripsForTodayFieldsAtom",
    default: defaultValueForFavouriteTripsForToday,
});

export const multiBookingPreferenceBackToAtom = atom<string>({
    key: "multiBookingPreferenceBackToAtom",
    default: "",
});

export const subActiveAccountActionAtom = atom<string>({
    key: "subActiveAccountActionAtom",
    default: "",
});

export const bookingsSearchResponseAtom = atom<IBookingsSearchResponse | null>({
    key: "bookingsSearchResponseAtom",
    default: null,
});

export const personalizeExperienceActiveTabAtom = atom<string>({
    key: "personalizeExperienceActiveTabAtom",
    default: "1",
});

export const defaultValueForGeneral = [
    {
        key: 1,
        name: "from",
        label: "From",
        value: "",
        valueLabel: "",
        placeHolder: "No Preference",
        drawerTitle: "Origin",
    },
    {
        key: 2,
        name: "to",
        label: "To",
        value: "",
        valueLabel: "",
        placeHolder: "No Preference",
        drawerTitle: "Destination",
    },
    {
        key: 3,
        name: "classTicketOption",
        label: "Class & Ticket Option",
        value: "",
        valueLabel: "",
        placeHolder: "No Preference",
        drawerTitle: "classTicketOption",
    },
    {
        key: 4,
        name: "seating",
        label: "Seating",
        value: "",
        valueLabel: "",
        placeHolder: "No Preference",
        drawerTitle: "seating",
    },
    {
        key: 5,
        name: "addOns",
        label: "Extras",
        value: "",
        valueLabel: "",
        placeHolder: "No Preference",
        drawerTitle: "addOns",
    },
];

export const generalFieldsAtom = atom<IExperienceFields[]>({
    key: "generalFieldsAtom",
    default: defaultValueForGeneral,
});

export const specialAssistancePrefAtom = atom<ISpecialAssistancePref[]>({
    key: 'specialAssistancePrefAtom',
    default: [],
});

export const defaultTravelsDays = [
    {
        key: 1,
        name: "Monday",
        isCheck: false,
        isDisable: false,
    },
    {
        key: 2,
        name: "Tuesday",
        isCheck: false,
        isDisable: false,
    },
    {
        key: 3,
        name: "Wednesday",
        isCheck: false,
        isDisable: false,
    },
    {
        key: 4,
        name: "Thursday",
        isCheck: false,
        isDisable: false,
    },
    {
        key: 5,
        name: "Friday",
        isCheck: false,
        isDisable: false,
    },
    {
        key: 6,
        name: "Saturday",
        isCheck: false,
        isDisable: false,
    },
    {
        key: 7,
        name: "Sunday",
        isCheck: false,
        isDisable: false,
    },
];

export const travelsDaysAtom = atom<ITravelDay[]>({
    key: "travelsDaysAtom",
    default: defaultTravelsDays,
});